import React, { useState } from "react";
import SvgEarth from "../_svg/Earth";

const languages = [
  {
    title: "🇫🇷",
    code: "fr",
  },
  {
    title: "🇬🇧",
    code: "en",
  },
];

const Menu = (props) => {
  const { content } = props;
  return (
    <div
      style={{
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: "rgb(51, 51, 51)"
      }}
    >
      {languages.map((el) => (
        <div className="section">
          <span>{el.title}</span>
        </div>
      ))}
    </div>
  );
};

const MiniMenu = (props) => {
  const { content } = props;
  const [clicked, setClicked] = useState(false)

  const handleClick = () => {
    setClicked(!clicked)
  }

  return (
    <div className="lang-selector">
      <div class="svg-box" onClick={()=> handleClick()} style={{ top: "2px", right: "2px" }}>
        <SvgEarth fill={"white"} height="3em"/>
      </div>
      {clicked && <Menu content={content} />}
    </div>
  );
};

export default MiniMenu;
